var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{key:this.key,staticClass:"input-knob",attrs:{"id":this.id,"type":"range","min":"0","max":"100","step":"0.1","data-diameter":this.width,"data-src":this.imgsrc},on:{"input":_vm.onInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }